import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "100%",
    [Orientation.LANDSCAPE]: "65%",
  },
};

export const ContainerSpacing = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "space-between",
  },
};

export const Titleposition = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "center",
    [Orientation.LANDSCAPE]: "center",
  },
};

export const BoxWrapperWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "100%",
    [Orientation.LANDSCAPE]: "358px",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "100%",
    [Orientation.LANDSCAPE]: "100%",
  },
};

export const WrapperWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: width => (width - 220) / 2,
    [Orientation.LANDSCAPE]: width => (width - 300) / 2,
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: width => width - 40,
    [Orientation.LANDSCAPE]: width => (width - 120) / 2,
  },
};

export const ContainerMarginTop = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "40",
    [Orientation.LANDSCAPE]: "10",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "14",
    [Orientation.LANDSCAPE]: "24",
  },
};

export const ConatinerMargin = {
  [Platform.WEB]: {
    [Orientation.LANDSCAPE]: "80",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "53",
  },
};

export const ConatinerMaxWidth = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "100",
  },
};

export const ConatinerMarginBottom = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "20",
    [Orientation.LANDSCAPE]: "20",
  },
};

export const TitleMarginLeft = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "0",
  },
};

export const CheckBoxSize = {
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "19",
    [Orientation.LANDSCAPE]: "19",
  },
};

export const CheckBoxMargin = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "21",
    [Orientation.LANDSCAPE]: "21",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "10",
    [Orientation.LANDSCAPE]: "15",
  },
};

export const CheckedImageHeight = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "14",
    [Orientation.LANDSCAPE]: "18",
  },
};

export const CheckedImageWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "14",
    [Orientation.LANDSCAPE]: "19",
  },
};
